var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('PCNavheader'),_c('router-view',{key:_vm.$route.path + _vm.$route.query.t}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-footer"},[_c('div',[_vm._v("区块链底层由维公链提供")]),_c('div',[_vm._v("区块链备案号："),_c('a',{attrs:{"href":"https://bcbeian.ifcert.cn"}},[_vm._v("粤网信备4401121967872434001X号")])])])
}]

export { render, staticRenderFns }